import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncreaseDim = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 45 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5857 43.5652C8.03275 43.5621 5.58524 42.5466 3.78007 40.7414C1.9749 38.9361 0.959476 36.4885 0.956543 33.9356L0.956543 9.71479C0.959589 7.16203 1.97511 4.71472 3.7803 2.90977C5.58549 1.10481 8.03294 0.0896215 10.5857 0.0869141L34.8061 0.0869141C37.3588 0.0895091 39.8063 1.10468 41.6115 2.90967C43.4166 4.71466 44.432 7.16204 44.4348 9.71479V33.9356C44.4321 36.4885 43.4168 38.9362 41.6117 40.7415C39.8066 42.5467 37.359 43.5622 34.8061 43.5652H10.5857ZM3.32526 9.71479V33.9356C3.32729 35.8606 4.09285 37.7063 5.45398 39.0676C6.81511 40.4289 8.66066 41.1946 10.5857 41.1969H34.8061C36.731 41.1945 38.5763 40.4287 39.9372 39.0674C41.2981 37.7061 42.0634 35.8605 42.0652 33.9356V9.71479C42.0632 7.79013 41.2978 5.94487 39.9369 4.58388C38.576 3.22289 36.7307 2.45734 34.8061 2.4552H10.5857C8.66088 2.45723 6.81547 3.2227 5.45434 4.58368C4.0932 5.94465 3.32751 7.78997 3.32526 9.71479ZM29.9297 31.615L22.7085 16.7378L15.6117 31.6142H10.9544L20.4391 12.0366H24.9519L34.4365 31.615H29.9297Z",
		fill: "#93DBC7"
	})
});
export default SvgIncreaseDim;
